import React, { useState } from 'react';
import styled from 'styled-components';

import Dropdown, { DropdownContainer, DropdownItem } from './Dropdown';
import Icon, { ClickableIcon } from './Icon';
import _theme from '../styles/theme';

type TermDropdownProps = {
  term: { [key: string]: any };
  openEditModal: (x: any) => void;
  openDeleteModal: (x: any) => void;
};

const TermDropdown = ({
  term,
  openEditModal,
  openDeleteModal
}: TermDropdownProps) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <DropdownContainer>
      <ClickableIcon
        ml={0.5}
        size={2}
        name="more-vertical"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!isOpen);
        }}
        style={{ color: _theme.color.primary }}
      />
      <Dropdown
        open={isOpen}
        style={{ whiteSpace: 'nowrap' }}
        setOpen={setOpen}
        align="right">
        <DropdownItem
          to="#"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
            openEditModal(term);
          }}>
          <Icon mr={1} name="pencil-edit" /> Edit Term
        </DropdownItem>
        <DropdownItem
          style={{
            color: _theme.color.danger,
          }}
          to="#"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
            openDeleteModal(term);
          }}>
          <Icon mr={1} name="trash" /> Delete Term
        </DropdownItem>
      </Dropdown>
    </DropdownContainer>
  );
};

export default TermDropdown;
